import { partition } from 'lodash'

export const checkValidProperty = property =>
  !!property && property.length !== 0 && property[0] !== ''

export const checkIsNearbySearch = (city, zip, county) =>
  checkValidProperty(city) ||
  checkValidProperty(zip) ||
  checkValidProperty(county)

const isAssetNearby = (
  { city: [city], zip: [zip], county: [county], globalSearch },
  listing
) => {
  // this is done to make sure global search doesn't bucket assets at all, this results in one big list and consistent ad injection
  if (globalSearch === 'y') {
    return true
  }
  if (checkValidProperty(city)) {
    return (
      String(listing.seller_property?.municipality).toLowerCase() ===
      String(city).toLowerCase()
    )
  } else if (checkValidProperty(zip)) {
    return (
      String(listing.seller_property.postal_code).toLowerCase() ===
      String(zip).toLowerCase()
    )
  } else if (checkValidProperty(county)) {
    return (
      String(
        listing.seller_property.country_secondary_subdivision
      ).toLowerCase() === String(county).toLowerCase()
    )
  }
  return true
}

export const partitionNearbyAssets = (filters, assetList) =>
  partition(assetList, listing => isAssetNearby(filters, listing))
